import { IApiMutationFunction, createApiMutationHook } from "../../utils/api";
import { RelationalValue } from "../../utils/filters";
import { getResourceUuid } from "../../utils/getResourceUuid";
import { IClassroom } from "../types/IClassroom";

export type IClassroomRemoveImageMutationParameters = {
    classroom: RelationalValue<IClassroom>;
};

export type IClassroomRemoveImageMutationResult = IClassroom;

export const classroomRemoveImageMutation: IApiMutationFunction<IClassroomRemoveImageMutationParameters> = ({
    classroom,
}) => {
    return {
        method: "DELETE",
        url: `/classrooms/${getResourceUuid(classroom)}/image`,
    };
};

export const useClassroomRemoveImageMutation = createApiMutationHook<
    IClassroomRemoveImageMutationParameters,
    IClassroomRemoveImageMutationResult
>(classroomRemoveImageMutation);
